/**
 * Extracts the part of an email address before the '@' symbol.
 * Returns an empty string if the email is undefined or has no '@'.
 */
export function getFirstPartOfEmail(email: string | undefined): string {
  return email?.split('@')[0] ?? '';
}
